var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-popover", { attrs: { width: "260", trigger: "click" } }, [
    _c("div", {}, [
      _c(
        "div",
        { staticClass: "flex-between padding-bottom-3" },
        [
          _c(
            "div",
            { staticClass: "flex-start" },
            [
              _c("Checkbox", {
                key: _vm.columnsShow.id,
                staticClass: "margin-right-15",
                attrs: {
                  indeterminate: _vm.indeterminate,
                  label: _vm.columnsShow.label,
                  disabled: "",
                },
                model: {
                  value: _vm.showColumns,
                  callback: function ($$v) {
                    _vm.showColumns = $$v
                  },
                  expression: "showColumns",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.resetColumns } },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "color-bg-f6 column-list border-radius-5 padding-x-10 padding-y-5",
        },
        [
          _c("TableColumnDragItem", {
            attrs: { list: _vm.checkedList },
            on: { onChange: _vm.onColumnChange },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "padding-5 pointer flex-center",
        attrs: { slot: "reference" },
        slot: "reference",
      },
      [
        _c("img", {
          style: { width: _vm.item.size + "px", height: _vm.item.size + "px" },
          attrs: { src: _vm.item.icon },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }